var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"board layout"},[[(_vm.board.boardNo != null && !_vm.isLoading)?_c(_vm.isComponent,{tag:"component",attrs:{"board":_vm.board,"grpList":_vm.grpList,"depth":_vm.depth}}):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }